import MenuButton from '@alifd/next/lib/menu-button';
export default MenuButton;